import React, { useEffect, useState } from 'react';
const INITIAL_SECONDS = 15 * 60;
function pad(value: number): string {
  return String(value).padStart(2, '0');
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex-1 rounded-[14px] bg-white p-5 text-center" data-id="element-227" data-mp="37us26r37f7qk">
      <p className="text-[40px] font-extrabold leading-none tabular-nums text-[#C9862E]" data-id="element-228" data-mp="32xi4ko5nvprn">{value}</p>
      <p className="mt-2 text-[12px] text-ink/60" data-id="element-229" data-mp="2yvwyblnmu9qf">{label}</p>
    </div>;
}
export function UrgencyBar() {
  const [secondsLeft, setSecondsLeft] = useState(INITIAL_SECONDS);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setSecondsLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const expired = secondsLeft === 0;
  return <div className="rounded-[16px] p-7 text-center" style={{
    background: 'linear-gradient(180deg, #D9963A 0%, #C9862E 100%)'
  }} data-id="element-230" data-mp="2b62hkt07010w">
      <p className="text-[22px] font-extrabold text-white" data-id="element-231" data-mp="1rvq1dopzskql">
        Offer{' '}
        <span className="underline decoration-2 underline-offset-[5px]" data-id="element-232" data-mp="1wp2jdg061tad">only for today</span>!
      </p>

      <p className="mx-auto mt-3 max-w-[380px] text-[15px] leading-[1.5] text-white/90" data-id="element-233" data-mp="1i0fv2osk9r70">
        Your discount is held for 15 minutes. After that, this page resets to full price.
      </p>

      <div className="mt-6" aria-live="polite" data-id="element-234" data-mp="2aotwzfmrt7nu">
        {expired ? <p className="mx-auto inline-block rounded-[999px] bg-white px-6 py-3 text-[16px] font-extrabold text-[#C9862E]" data-id="element-235" data-mp="2fmmznyov7jjd">
            Offer ending
          </p> : <div className="flex items-stretch gap-4" data-id="element-236" data-mp="21pgi27fvnqvq">
            <TimeBox value={pad(minutes)} label="Minutes" data-id="element-237" data-mp="25ne9lgx4ep2a" />
            <TimeBox value={pad(seconds)} label="Seconds" data-id="element-238" data-mp="q871bso4vcy4" />
          </div>}
      </div>
    </div>;
}